<!-- Campos de Stripe Elements. Cada div es el contenedor donde Stripe monta su
     iframe: el número de tarjeta nunca existe en nuestro DOM. -->
<div class="stripe-card">

    <!-- Número de tarjeta -->
    <div class="row">
        <div class="col-12 form-group" [ngClass]="{'has-danger': numberError}">
            <label class="font-l1">Número de tarjeta <span class="text-danger">*</span></label>
            <div #cardNumber class="form-control stripe-element"></div>
            <small class="form-control-feedback" *ngIf="numberError">
                {{numberError}}
            </small>
        </div>
    </div>

    <!-- Expiración / CVC -->
    <div class="row">
        <div class="form-group col-7" [ngClass]="{'has-danger': expiryError}">
            <label class="font-l1">Expiración <span class="text-danger">*</span></label>
            <div #cardExpiry class="form-control stripe-element"></div>
            <small class="form-control-feedback" *ngIf="expiryError">
                {{expiryError}}
            </small>
        </div>

        <div class="form-group col-5" [ngClass]="{'has-danger': cvcError}">
            <label class="font-l1">CVC <span class="text-danger">*</span></label>
            <div #cardCvc class="form-control stripe-element"></div>
            <small class="form-control-feedback" *ngIf="cvcError">
                {{cvcError}}
            </small>
        </div>
    </div>

    <div class="row" *ngIf="loading">
        <div class="col-12 font-10">
            Cargando el formulario de pago...
        </div>
    </div>
</div>
